package co.torvus.web.components

import co.torvus.web.classes
import co.torvus.web.content.navItems
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.nav
import react.dom.html.ReactHTML.span
import web.cssom.ClassName

external interface NavBarProps : Props {
    var active: String
    var onNavigate: (String) -> Unit
    var onOpenMenu: () -> Unit
}

val NavBar = FC<NavBarProps> { props ->
    nav {
        className = ClassName("nav")

        button {
            className = ClassName("logo")
            onClick = { props.onNavigate("home") }
            img {
                src = "icons/torvus_logo_negative.svg"
                alt = "Torvus"
            }
        }

        div {
            className = ClassName("nav-links")
            navItems.forEach { item ->
                button {
                    className = classes("nav-link", if (props.active == item.id) "active" else null)
                    onClick = { props.onNavigate(item.id) }
                    +item.label
                }
            }
        }

        button {
            className = ClassName("burger")
            onClick = { props.onOpenMenu() }
            span {}
            span {}
            span {}
        }
    }
}
